<template>
  <div>
    <el-dialog
      left
      :title="title"
      :closeOnClickModal="false"
      :closeOnPressEscape="false"
      width="520px"
      style="margin: 0 auto"
      :visible.sync="isShow"
      @close="handleCancel()"
      class="investment-modal col-lg-12 col-sm-12 col-12 col-md-12"
    >
      <form @submit.prevent="lpSave">
        <div class="row">
          <div class="col-6">
            <div class="formLabel">
              Entity Name
              <span class="required">*</span>
            </div>
            <input
              type="text"
              class="form-control team-form"
              style="width: 100%"
              required
              v-model="value.data.entity_name"
              placeholder="Entity Name"
            />
          </div>
          <!-- <div class="col-6">
            <div class="formLabel">
              Entity type
              <span class="required">*</span>
            </div>
            <el-select
              class="todo-dropdown-el-select"
              v-model="value.data.entity_type"
              size="large"
              placeholder="Entity type"
              disabled
            >
              <el-option v-for="item in entityType" :value="item" :label="item" :key="item"></el-option>
            </el-select>
          </div>-->
          <div class="col-6">
            <div class="formLabel">
              Capital Commitment
              <span class="required">*</span>
            </div>
            <input
              type="number"
              min="0"
              step=".01"
              class="form-control team-form"
              style="width: 100%"
              required
              v-model="value.data.capital_commitment"
              placeholder="Capital Commitment"
              @keyup="ownershipChange"
            />
          </div>
        </div>
        <!-- <div class="row">
          <div class="col-6">
            <div class="formLabel">
              Capital Commitment
              <span class="required">*</span>
            </div>
            <input
              type="number"
              min="0"
              class="form-control team-form"
              style="width: 100%;"
              required
              v-model="value.data.capital_commitment"
              placeholder="Capital Commitment"
              @keyup="ownershipChange"
            />
          </div>
          <div class="col-6">
            <div class="formLabel">
              Ownership %
              <span class="required">*</span>
            </div>
            <input
              type="number"
              class="form-control team-form"
              style="width: 100%;"
              required
              v-model="value.data.ownership"
              placeholder="Ownership %"
              @keyup="ownershipChange"
              min="0"
              max="100"
              disabled
            />
          </div>
        </div>-->
        <div class="row">
          <!-- <div class="col-6">
            <div class="formLabel">Open Balance</div>
            <input
              type="text"
              class="form-control team-form"
              style="width: 100%;"
              v-model="value.data.open_balance"
              placeholder="Open Balance"
              @keyup="contributedToDateChange"
            />
          </div>-->
          <div class="col-6">
            <div class="formLabel">Contributed to Date</div>
            <input
              type="Number"
              min="0"
              step=".01"
              class="form-control team-form"
              style="width: 100%"
              v-model="value.data.contributed_to_date"
              placeholder="Contributed to Date"
              @keyup="contributedToDateChange"
            />
          </div>
        </div>
        <div class="row pb-2" style="padding-top: 15px">
          <div class="col-6 formLabel">Capital Called</div>
          <div class="col-6" v-if="capitalCalled">{{ capitalCalled }}</div>
          <div class="col-6" v-else>-</div>
        </div>
        <div class="row pb-2">
          <div class="col-6 formLabel">Remaining Commitment</div>
          <div class="col-6" v-if="remainingCommitment">
            {{ remainingCommitment }}
          </div>
          <div class="col-6" v-else>-</div>
        </div>
        <!-- <div class="row pb-2">
          <div class="col-6 formLabel">Contributed to Date</div>
          <div class="col-6" v-if="contributedToDate">{{contributedToDate}}</div>
          <div class="col-6" v-else>-</div>
        </div>-->
        <!-- <div class="row pb-2">
          <div class="col-6 formLabel">Distributions</div>
          <div class="col-6" v-if="distributions">{{distributions}}</div>
          <div class="col-6" v-else>-</div>
        </div>-->
        <!-- <div class="row pb-2">
          <div class="col-6 formLabel">Share of Fees</div>
          <div class="col-6" v-if="shareOfFees">{{shareOfFees}}</div>
          <div class="col-6" v-else>-</div>
        </div>-->
        <!-- <div class="row pb-2">
          <div class="col-6 formLabel">Share Of carried cash</div>
          <div class="col-6">- {{value.data.share_of_carried_cash}}</div>
        </div>-->
        <!-- <div class="row pb-2">
          <div class="col-6 formLabel">Profit %</div>
          <div class="col-6" v-if="profit">{{profit}}</div>
          <div class="col-6" v-else>-</div>
        </div>-->
        <div class="edit-company-action-button-row pt-3" style="margin: 0px">
          <button
            type="button"
            @click="handleCancel()"
            class="todo-form-cancel-button btn-outline-secondary"
          >
            Cancel
          </button>
          <!-- @click="registrarSave" -->
          <button
            type="submit"
            :disabled="isSaving"
            class="todo-form-submit-button btn btn-primary"
            style="height: 35px"
          >
            Save
            <b-spinner
              v-if="isSaving"
              style="float: right"
              small
              label="Loading..."
            ></b-spinner>
          </button>
        </div>
      </form>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog } from "element-ui";
import moment from "moment";
import { vals, humanFileSize } from "../../../util";
import { Select, Option } from "element-ui";
import { formatCurrency, formatNumberWithComma } from "../../../util";
import { mapGetters } from "vuex";
export default {
  components: {
    [Dialog.name]: Dialog,
    [Select.name]: Select,
    [Option.name]: Option,
  },
  computed: {
    ...mapGetters("user", ["currency"]),
    ...mapGetters("portfolio", ["portfolioData"]),
    isShow: {
      get() {
        this.initializeModal();
        return this.value.isShow;
      },
      set(value) {
        this.value.isShow = value;
      },
    },
    title: {
      get() {
        return this.value.isCreate
          ? "Add LP Allocations"
          : "Edit LP Allocations";
      },
    },
    capitalCalled() {
      return this.capitalCalledValue
        ? formatCurrency(this.capitalCalledValue, this.currency.ref, 0, true)
        : 0;
    },
    contributedToDate() {
      return this.contributedToDateValue
        ? formatCurrency(
            this.contributedToDateValue,
            this.currency.ref,
            0,
            true
          )
        : 0;
    },
    remainingCommitment() {
      return this.remainingCommitmentValue
        ? formatCurrency(
            this.remainingCommitmentValue,
            this.currency.ref,
            0,
            true
          )
        : 0;
    },
    shareOfFees() {
      return this.shareOfFeesValue
        ? formatCurrency(this.shareOfFeesValue, this.currency.ref, 0, true)
        : 0;
    },
    distributions() {
      let retval = this.distributionsValue
        ? formatNumberWithComma(Number(this.distributionsValue))
        : 0;
      return retval ? `$${retval}` : 0;
    },
    profit() {
      return Number(this.profitValue) ? `${Number(this.profitValue)}%` : 0;
    },
    portfolioValue() {
      // sum up our portfolio value
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.value)) sum += item.value;
        });
      }
      return sum;
    },
    portfolioCost() {
      // sum up our porfolio cost
      let sum = 0;
      if (this.portfolioData && this.portfolioData.length) {
        this.portfolioData.map((item) => {
          if (Number.isInteger(item.cost)) sum += item.cost;
        });
      }
      return sum;
    },
  },
  props: {
    value: {
      isShow: Boolean,
      data: Object,
      isCreate: Boolean,
      detailsData: Array,
      summaryData: Object,
      previousCapital: Number,
      previousCapitalCalledToDate: Number,
    },
  },
  data() {
    return {
      entityType: ["LP", "GP"],
      isSaving: false,
      capitalCalledValue: 0,
      contributedToDateValue: 0,
      remainingCommitmentValue: 0,
      shareOfFeesValue: 0,
      distributionsValue: 0,
      profitValue: 0,
    };
  },
  methods: {
    handleCancel() {
      this.isShow = false;
      this.isSaving = false;
      this.capitalCalledValue = 0;
      this.contributedToDateValue = 0;
      this.remainingCommitmentValue = 0;
      this.shareOfFeesValue = 0;
      this.distributionsValue = 0;
    },
    lpSave() {
      this.ownershipChange();
      const self = this;
      let serverData = JSON.parse(JSON.stringify(this.value.data));
      serverData.ownership =
        serverData.ownership && Number(serverData.ownership) > 0
          ? Number(serverData.ownership)
          : 0;
      serverData.capital_commitment =
        serverData.capital_commitment &&
        Number(serverData.capital_commitment) > 0
          ? Number(serverData.capital_commitment)
          : 0;
      serverData.capital_called =
        serverData.capital_called && Number(serverData.capital_called) > 0
          ? Number(serverData.capital_called)
          : 0;
      serverData.open_balance =
        serverData.open_balance && Number(serverData.open_balance)
          ? Number(serverData.open_balance)
          : 0;
      serverData.remaining_commitment =
        serverData.remaining_commitment &&
        Number(serverData.remaining_commitment)
          ? Number(serverData.remaining_commitment)
          : 0;
      serverData.contributed_to_date =
        serverData.contributed_to_date &&
        Number(serverData.contributed_to_date) > 0
          ? Number(serverData.contributed_to_date)
          : 0;
      serverData.distributions =
        serverData.distributions && Number(serverData.distributions) > 0
          ? Number(serverData.distributions)
          : 0;
      serverData.share_of_fees =
        serverData.share_of_fees && Number(serverData.share_of_fees) > 0
          ? Number(serverData.share_of_fees)
          : 0;
      if (this.value.summaryData && this.value.summaryData._id) {
        serverData.lp_summary_id = this.value.summaryData._id;
      }
      //serverData.contributed_to_date = Number(this.contributedToDateValue);
      // serverData.capital_called_to_date = self.value.isCreate
      //   ? Number(serverData.capital_called)
      //   : Number(serverData.capital_called_to_date);
      serverData.profit =
        serverData.profit && Number(serverData.profit)
          ? Number(serverData.profit)
          : 0;
      serverData.lp_percentage =
        serverData.lp_percentage && Number(serverData.lp_percentage)
          ? Number(serverData.lp_percentage)
          : 0;
      self.isSaving = true;
      let url = self.value.isCreate
        ? "lpAllocations/apiPostDetailsData"
        : "lpAllocations/apiPatchDetailsData";
      self.$store
        .dispatch(url, serverData)
        .then((user) => {
          self.value.detailsData =
            self.$store.getters["lpAllocations/detailsData"];
          let summaryData = self.$store.getters["lpAllocations/summaryData"];
          self.value.summaryData =
            summaryData && summaryData.length > 0 ? summaryData[0] : {};
          // if (self.value.detailsData && self.value.detailsData.length == 1) {
          //   self
          //     .addGpCarry(self.value.summaryData)
          //     .then((data) => {
          //       self.$emit("emit-success");
          //       self.handleCancel();
          //       self.$toaster.success("Saved Successfully.");
          //     })
          //     .catch((error) => {
          //       console.log("error from add gp carry in details", error);
          //       this.isSaving = false;
          //       this.$toaster.error("Fail to add Details Data");
          //     });
          // }
          self
            .updateLpDetails()
            .then((data) => {
              self
                .updateDistributionCallData()
                .then((updateDistributionCallData) => {
                  self
                    .updateDetailsDataDistributions()
                    .then((updateDetailsCallDistributionData) => {
                      self
                        .updateCurrentCapitalCallData()
                        .then((currentCapitalData) => {
                          self
                            .updateSummaryData()
                            .then((updateSummaryData) => {
                              self.$emit("emit-success");
                              self.handleCancel();
                              self.$toaster.success("Saved Successfully.");
                            })
                            .catch((error) => {
                              console.log(
                                "error from updateSummaryData inside updateCurrentCapitalCallData inside updateLpDetails ",
                                error
                              );
                              this.isSaving = false;
                              this.$toaster.error("Fail to add Details Data");
                            });
                        })
                        .catch((error) => {
                          console.log(
                            "error from updateCurrentCapitalCallData inside updateLpDetails ",
                            error
                          );
                          this.isSaving = false;
                          this.$toaster.error("Fail to add Details Data");
                        });
                    })
                    .catch((error) => {
                      console.log(
                        "error from updateDetailsDataDistributions inside updateDistributionCallData inside updateLpDetails ",
                        error
                      );
                      this.isSaving = false;
                      this.$toaster.error("Fail to add Details Data");
                    });
                })
                .catch((error) => {
                  console.log(
                    "error from updateDistributionCallData inside updateLpDetails ",
                    error
                  );
                  this.isSaving = false;
                  this.$toaster.error("Fail to add Details Data");
                });
            })
            .catch((error) => {
              console.log("error from bulk calculations", error);
              this.isSaving = false;
              this.$toaster.error("Fail to add Details Data");
            });
        })
        .catch((err) => {
          this.isSaving = false;
          this.$toaster.error("Fail to add Details Data");
        });
    },
    ownershipChange() {
      const self = this;
      let capitalCommitment =
        this.value.data.capital_commitment &&
        Number(this.value.data.capital_commitment) > 0
          ? Number(this.value.data.capital_commitment)
          : 0;
      let fundDetails = self.$store.getters["lpAllocations/fundDetailsData"];
      let fundDetailsCapitalCommitment =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("capital_commitment") &&
        Number(fundDetails[0].capital_commitment)
          ? Number(fundDetails[0].capital_commitment)
          : 0;
      if (self.value.isCreate) {
        fundDetailsCapitalCommitment += Number(capitalCommitment);
      } else {
        let presentValue = Number(
          (
            Number(this.value.previousFundCapitalCommitment) -
            Number(this.value.previousCapitalCommitment)
          ).toFixed(2)
        );
        fundDetailsCapitalCommitment =
          Number(presentValue) + Number(capitalCommitment);
      }
      this.value.data.ownership = Number(
        (
          (Number(capitalCommitment) / Number(fundDetailsCapitalCommitment)) *
          100
        ).toFixed()
      );
      let ownership =
        this.value.data.ownership && Number(this.value.data.ownership) > 0
          ? Number(this.value.data.ownership)
          : 0;
      this.value.data.capital_called =
        // capital commitment of each lp detail*(capital_called_to_date_percentage/100)
        capitalCommitment &&
        this.value.summaryData &&
        this.value.summaryData.hasOwnProperty("capital_called_to_date") &&
        Number(this.value.summaryData.capital_called_to_date) > 0
          ? Number(
              (
                Number(capitalCommitment) *
                (Number(this.value.summaryData.capital_called_to_date) / 100)
              ).toFixed(2)
            )
          : 0;
      this.capitalCalledValue = this.value.data.capital_called;
      this.contributedToDateChange();
    },
    initializeModal() {
      this.capitalCalledValue = this.value.data.capital_called;
      this.contributedToDateValue = this.value.data.contributed_to_date;
      this.remainingCommitmentValue = this.value.data.remaining_commitment;
      this.shareOfFeesValue = this.value.data.share_of_fees;
      this.distributionsValue = this.value.data.distributions;
      this.profitValue = this.value.data.profit;
      this.ownershipChange();
      // this.entityTypeChange();
    },
    entityTypeChange() {
      if (
        this.value.data.entity_type &&
        this.value.data.entity_type.length > 0
      ) {
        // if (this.value.data.entity_type == "LP") {
        //   if (
        //     this.value.summaryData &&
        //     this.value.summaryData.hasOwnProperty("current_call") &&
        //     this.value.summaryData.current_call == 1
        //   ) {
        //     if (this.value.detailsData && this.value.detailsData.length == 0) {
        //       this.value.data.share_of_fees =
        //         this.value.summaryData.hasOwnProperty("management_fees") &&
        //         Number(this.value.summaryData.management_fees) > 0
        //           ? Number(this.value.summaryData.management_fees)
        //           : 0;
        //     } else {
        //       let ownershipLoopValues = 0;
        //       this.value.detailsData.map((item) => {
        //         if (
        //           item.entity_type == "LP" &&
        //           item.hasOwnProperty("ownership") &&
        //           Number(item.ownership) > 0
        //         ) {
        //           if (!this.value.data.hasOwnProperty("_id")) {
        //             ownershipLoopValues += Number(item.ownership);
        //           } else {
        //             if (item._id != this.value.data._id) {
        //               ownershipLoopValues += Number(item.ownership);
        //             }
        //           }
        //         }
        //       });
        //       let ownership =
        //         this.value.data.ownership &&
        //         Number(this.value.data.ownership) > 0
        //           ? Number(this.value.data.ownership)
        //           : 0;
        //       ownershipLoopValues += ownership;
        //       this.value.data.share_of_fees =
        //         this.value.summaryData.hasOwnProperty("management_fees") &&
        //         Number(this.value.summaryData.management_fees) > 0
        //           ? Number(
        //               (
        //                 (Number(ownership) / Number(ownershipLoopValues)) *
        //                 Number(this.value.summaryData.management_fees)
        //               ).toFixed(2)
        //             )
        //           : 0;
        //     }
        //   } else {
        //     this.value.data.share_of_fees = 0;
        //   }
        // } else {
        //   this.value.data.share_of_fees = 0;
        // }
        // this.shareOfFeesValue = this.value.data.share_of_fees;
        let gpCarry = 0;
        let totalLpOwnership = 0;
        let ownership =
          this.value.data.ownership && Number(this.value.data.ownership) > 0
            ? Number(this.value.data.ownership)
            : 0;
        if (this.value.detailsData && this.value.detailsData.length > 0) {
          this.value.detailsData.map((item) => {
            if (
              item &&
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "GP Carry"
            ) {
              if (item.hasOwnProperty("profit") && Number(item.profit) > 0) {
                gpCarry = Number(item.profit);
              }
            }
            if (
              item &&
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "LP" &&
              item.hasOwnProperty("ownership") &&
              Number(item.ownership) > 0
            ) {
              totalLpOwnership += Number(item.ownership);
            }
          });
        }
        if (this.value.data.entity_type == "LP") {
          totalLpOwnership += Number(ownership);
        }
        this.value.data.profit =
          Number(ownership) > 0
            ? Number(
                ((1 - Number(gpCarry) / 100) * Number(ownership)).toFixed(2)
              )
            : 0;
        this.profitValue = this.value.data.profit;
        this.value.data.lp_percentage =
          Number(ownership) > 0
            ? Number(
                ((Number(ownership) / Number(totalLpOwnership)) * 100).toFixed(
                  2
                )
              )
            : 0;
        //this.distibutionCalculations();
        this.newDistributionCalculations();
      }
    },
    distibutionCalculations() {
      let ownership =
        this.value.data.ownership && Number(this.value.data.ownership) > 0
          ? Number(this.value.data.ownership)
          : 0;
      let profit =
        this.value.data.profit && Number(this.value.data.profit) > 0
          ? Number(this.value.data.profit)
          : 0;
      // let ownershipLoopValues = 0;
      // let gpOwnershipLoopValues = 0;
      // if (this.value.detailsData && this.value.detailsData.length > 0) {
      //   this.value.detailsData.map((item) => {
      //     if (item.hasOwnProperty("ownership") && Number(item.ownership) > 0) {
      //       if (!this.value.data.hasOwnProperty("_id")) {
      //         if (item.entity_type == "LP") {
      //           ownershipLoopValues += Number(item.ownership);
      //         } else {
      //           if (item.entity_type == "GP") {
      //             gpOwnershipLoopValues += Number(item.ownership);
      //           }
      //         }
      //       } else {
      //         if (item._id != this.value.data._id) {
      //           if (item.entity_type == "LP") {
      //             ownershipLoopValues += Number(item.ownership);
      //           } else {
      //             if (item.entity_type == "GP") {
      //               gpOwnershipLoopValues += Number(item.ownership);
      //             }
      //           }
      //         }
      //       }
      //     }
      //   });
      // }
      // if (this.value.data.entity_type == "LP") {
      //   ownershipLoopValues += ownership;
      // } else {
      //   if (this.value.data.entity_type == "GP") {
      //     gpOwnershipLoopValues += ownership;
      //   }
      // }
      if (
        this.value.summaryData &&
        this.value.summaryData.hasOwnProperty("distributions") &&
        this.value.summaryData.hasOwnProperty("distributions_pre_carry") &&
        this.value.summaryData.hasOwnProperty("distributions_in_carry") &&
        Number(this.value.summaryData.distributions) > 0 &&
        Number(this.value.summaryData.distributions_pre_carry) &&
        Number(this.value.summaryData.distributions_in_carry)
      ) {
        if (
          this.value.summaryData.hasOwnProperty("distributed_to_date") &&
          this.value.summaryData.hasOwnProperty("capital_commitment") &&
          Number(this.value.summaryData.distributed_to_date) >
            Number(this.value.summaryData.capital_commitment)
        ) {
          if (
            this.value.summaryData.hasOwnProperty(
              "distributions_exceed_to_date"
            ) &&
            Number(this.value.summaryData.distributions_exceed_to_date) == 1
          ) {
            //for the very first time if distributed to date exceeds capital commitment of summary
            /*
            let difference=distributed to date - capital commitment of summary
            let gpshare1=gp's get 20% of difference
            let lpshare1=100% of (distributed to investors-difference)
            let lpshare2=80% of (difference-gpshare1)
            let gpshare2=20% of (difference-gpshare1)
            distributions for gp=gpshare1+gpshare2
            distributions for lp=((ownership% of lp/(sum of all ownership% of lp's))*(lpshare1+lpshare2))
            */
            // let difference = Number(
            //   (
            //     Number(this.value.summaryData.distributed_to_date) -
            //     Number(this.value.summaryData.capital_commitment)
            //   ).toFixed(2)
            // );
            // let gpshare1 = Number(((20 / 100) * Number(difference)).toFixed(2));
            // let lpshare1 = Number(
            //   (
            //     Number(this.value.summaryData.distributions) -
            //     Number(difference)
            //   ).toFixed(2)
            // );
            // let lpshare2 = Number(
            //   ((80 / 100) * (Number(difference) - Number(gpshare1))).toFixed(2)
            // );
            // let gpshare2 = Number(
            //   ((20 / 100) * (Number(difference) - Number(gpshare1))).toFixed(2)
            // );
            // this.value.data.distributions =
            // this.value.data.entity_type == "LP"
            //   ? Number(ownership) > 0
            //     ? Number(
            //         (
            //           (Number(ownership) / Number(ownershipLoopValues)) *
            //           (Number(lpshare1) + Number(lpshare2))
            //         ).toFixed(2)
            //       )
            //     : 0
            //   : Number(ownership) > 0
            //   ? Number(
            //       (
            //         (Number(ownership) / Number(gpOwnershipLoopValues)) *
            //         (Number(gpshare1) + Number(gpshare2))
            //       ).toFixed(2)
            //     )
            //   : 0;
            this.value.data.distributions = Number(
              (
                Number(this.value.summaryData.distributions_pre_carry) *
                  Number(ownership) +
                Number(this.value.summaryData.distributions_in_carry) *
                  Number(profit)
              ).toFixed(2)
            );
          }
          //Number(gpshare1) + Number(gpshare2);
          else {
            // let gpshare1=(20/100)*distributed to investors of summary
            // let lpshare1=(80/100)*(distributed to investors of summary-gpshare1)
            // let gpshare2=(20/100)*(distributed to investors of summary-gpshare1)
            // distributions for gp=gpshare1+gpshare2
            // distributions for lp=((ownership% of lp/(sum of all ownership% of lp's))*(lpshare1))
            let gpshare1 = Number(
              (
                (20 / 100) *
                Number(this.value.summaryData.distributions)
              ).toFixed(2)
            );
            let lpshare1 = Number(
              (
                (80 / 100) *
                (Number(this.value.summaryData.distributions) -
                  Number(gpshare1))
              ).toFixed(2)
            );
            let gpshare2 = Number(
              (
                (20 / 100) *
                (Number(this.value.summaryData.distributions) -
                  Number(gpshare1))
              ).toFixed(2)
            );
            this.value.data.distributions =
              this.value.data.entity_type == "LP"
                ? Number(ownership) > 0
                  ? Number(
                      (
                        (Number(ownership) / Number(ownershipLoopValues)) *
                        Number(lpshare1)
                      ).toFixed(2)
                    )
                  : 0
                : Number(ownership) > 0
                ? Number(
                    (
                      (Number(ownership) / Number(gpOwnershipLoopValues)) *
                      (Number(gpshare1) + Number(gpshare2))
                    ).toFixed(2)
                  )
                : 0;
          } //Number(gpshare1) + Number(gpshare2);
        }
        //if distributed to date does not exceed capital commitment of summary
        else {
          this.value.data.distributions =
            this.value.data.entity_type == "LP"
              ? Number(ownership) > 0
                ? Number(
                    (
                      (Number(ownership) / Number(ownershipLoopValues)) *
                      Number(this.value.summaryData.distributions)
                    ).toFixed(2)
                  )
                : 0
              : 0;
        }
        this.distributionsValue = this.value.data.distributions;
      }
    },
    newDistributionCalculations() {
      let ownership =
        this.value.data.ownership && Number(this.value.data.ownership) > 0
          ? Number(this.value.data.ownership)
          : 0;
      let profit =
        this.value.data.profit && Number(this.value.data.profit) > 0
          ? Number(this.value.data.profit)
          : 0;
      if (
        this.value.summaryData &&
        this.value.summaryData.hasOwnProperty("distributions") &&
        this.value.summaryData.hasOwnProperty("distributions_pre_carry") &&
        this.value.summaryData.hasOwnProperty("distributions_in_carry") &&
        Number(this.value.summaryData.distributions) > 0 &&
        Number(this.value.summaryData.distributions_pre_carry) &&
        Number(this.value.summaryData.distributions_in_carry)
      ) {
        this.value.data.distributions = Number(
          (
            Number(this.value.summaryData.distributions_pre_carry) *
              (Number(ownership) / 100) +
            Number(this.value.summaryData.distributions_in_carry) *
              (Number(profit) / 100)
          ).toFixed(2)
        );
      } else {
        this.value.data.distributions = 0;
      }
    },
    shareOfFeesAndDistributionCalculations() {
      const self = this;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (self.value.detailsData && self.value.detailsData.length > 0) {
          let ownershipLoopValues = 0;
          let gpOwnershipLoopValues = 0;
          this.value.detailsData.map((item) => {
            if (
              item.hasOwnProperty("ownership") &&
              Number(item.ownership) > 0
            ) {
              if (item.entity_type == "LP") {
                ownershipLoopValues += Number(item.ownership);
              } else {
                if (item.entity_type == "GP") {
                  gpOwnershipLoopValues += Number(item.ownership);
                }
              }
            }
          });
          self.value.detailsData.map((item) => {
            if (
              item.hasOwnProperty("share_of_fees") &&
              item.hasOwnProperty("entity_type")
            ) {
              if (item.entity_type == "LP") {
                if (
                  this.value.summaryData &&
                  this.value.summaryData.hasOwnProperty("current_call") &&
                  this.value.summaryData.current_call == 1
                ) {
                  let ownership =
                    item.hasOwnProperty("ownership") &&
                    item.ownership &&
                    Number(item.ownership) > 0
                      ? Number(item.ownership)
                      : 0;
                  item.share_of_fees =
                    this.value.summaryData.hasOwnProperty("management_fees") &&
                    Number(this.value.summaryData.management_fees) > 0
                      ? Number(
                          (
                            (Number(ownership) / Number(ownershipLoopValues)) *
                            Number(this.value.summaryData.management_fees)
                          ).toFixed(2)
                        )
                      : 0;
                } else {
                  item.share_of_fees = 0;
                }
              } else {
                item.share_of_fees = 0;
              }
            }
            if (
              item.hasOwnProperty("entity_type") &&
              item.hasOwnProperty("distributions") &&
              item.hasOwnProperty("ownership")
            ) {
              let ownership =
                item.hasOwnProperty("ownership") &&
                item.ownership &&
                Number(item.ownership) > 0
                  ? Number(item.ownership)
                  : 0;
              if (
                this.value.summaryData &&
                this.value.summaryData.hasOwnProperty("distributions") &&
                Number(this.value.summaryData.distributions) > 0
              ) {
                if (
                  this.value.summaryData.hasOwnProperty(
                    "distributed_to_date"
                  ) &&
                  this.value.summaryData.hasOwnProperty("capital_commitment") &&
                  Number(this.value.summaryData.distributed_to_date) >
                    Number(this.value.summaryData.capital_commitment)
                ) {
                  if (
                    this.value.summaryData.hasOwnProperty(
                      "distributions_exceed_to_date"
                    ) &&
                    Number(
                      this.value.summaryData.distributions_exceed_to_date
                    ) == 1
                  ) {
                    //for the very first time if distributed to date exceeds capital commitment of summary
                    /*
                    let difference=distributed to date - capital commitment of summary
                    let gpshare1=gp's get 20% of difference
                    let lpshare1=100% of (distributed to investors-difference)
                    let lpshare2=80% of (difference-gpshare1)
                    let gpshare2=20% of (difference-gpshare1)
                    distributions for gp=gpshare1+gpshare2
                    distributions for lp=((ownership% of lp/(sum of all ownership% of lp's))*(lpshare1+lpshare2))
                    */
                    let difference = Number(
                      (
                        Number(this.value.summaryData.distributed_to_date) -
                        Number(this.value.summaryData.capital_commitment)
                      ).toFixed(2)
                    );
                    let gpshare1 = Number(
                      ((20 / 100) * Number(difference)).toFixed(2)
                    );
                    let lpshare1 = Number(
                      (
                        Number(this.value.summaryData.distributions) -
                        Number(difference)
                      ).toFixed(2)
                    );
                    let lpshare2 = Number(
                      (
                        (80 / 100) *
                        (Number(difference) - Number(gpshare1))
                      ).toFixed(2)
                    );
                    let gpshare2 = Number(
                      (
                        (20 / 100) *
                        (Number(difference) - Number(gpshare1))
                      ).toFixed(2)
                    );
                    item.distributions =
                      item.entity_type == "LP"
                        ? Number(ownership) > 0
                          ? Number(
                              (
                                (Number(ownership) /
                                  Number(ownershipLoopValues)) *
                                (Number(lpshare1) + Number(lpshare2))
                              ).toFixed(2)
                            )
                          : 0
                        : Number(ownership) > 0
                        ? Number(
                            (
                              (Number(ownership) /
                                Number(gpOwnershipLoopValues)) *
                              (Number(gpshare1) + Number(gpshare2))
                            ).toFixed(2)
                          )
                        : 0;
                  }
                  //Number(gpshare1) + Number(gpshare2)
                  else {
                    // let gpshare1=(20/100)*distributed to investors of summary
                    // let lpshare1=(80/100)*(distributed to investors of summary-gpshare1)
                    // let gpshare2=(20/100)*(distributed to investors of summary-gpshare1)
                    // distributions for gp=gpshare1+gpshare2
                    // distributions for lp=((ownership% of lp/(sum of all ownership% of lp's))*(lpshare1))
                    let gpshare1 = Number(
                      (
                        (20 / 100) *
                        Number(this.value.summaryData.distributions)
                      ).toFixed(2)
                    );
                    let lpshare1 = Number(
                      (
                        (80 / 100) *
                        (Number(this.value.summaryData.distributions) -
                          Number(gpshare1))
                      ).toFixed(2)
                    );
                    let gpshare2 = Number(
                      (
                        (20 / 100) *
                        (Number(this.value.summaryData.distributions) -
                          Number(gpshare1))
                      ).toFixed(2)
                    );
                    item.distributions =
                      item.entity_type == "LP"
                        ? Number(ownership) > 0
                          ? Number(
                              (
                                (Number(ownership) /
                                  Number(ownershipLoopValues)) *
                                Number(lpshare1)
                              ).toFixed(2)
                            )
                          : 0
                        : Number(ownership) > 0
                        ? Number(
                            (
                              (Number(ownership) /
                                Number(gpOwnershipLoopValues)) *
                              (Number(gpshare1) + Number(gpshare2))
                            ).toFixed(2)
                          )
                        : 0;
                  } //Number(gpshare1) + Number(gpshare2)
                } else {
                  item.distributions =
                    item.entity_type == "LP"
                      ? Number(ownership) > 0
                        ? Number(
                            (
                              (Number(ownership) /
                                Number(ownershipLoopValues)) *
                              Number(this.value.summaryData.distributions)
                            ).toFixed(2)
                          )
                        : 0
                      : 0;
                }
              }
            }
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateLpDetails() {
      const self = this;
      let payload = [];
      return new Promise((resolve, reject) => {
        self
          .updateGpDetails()
          .then((data) => {
            self
              .updateLpOwnership()
              .then((ownershipData) => {
                let gpData = self.$store.getters["lpAllocations/gpDetailsData"];
                let lpData = self.$store.getters["lpAllocations/lpDetailsData"];
                let fundDetails =
                  self.$store.getters["lpAllocations/fundDetailsData"];
                // console.log("fund details : ", fundDetails);
                let fundDetailsCapitalCommitment =
                  fundDetails &&
                  fundDetails.length > 0 &&
                  fundDetails[0] &&
                  fundDetails[0].hasOwnProperty("capital_commitment") &&
                  Number(fundDetails[0].capital_commitment)
                    ? Number(fundDetails[0].capital_commitment)
                    : 0;
                let fundDetailsFundPercentage =
                  fundDetails &&
                  fundDetails.length > 0 &&
                  fundDetails[0] &&
                  fundDetails[0].hasOwnProperty("ownership") &&
                  Number(fundDetails[0].ownership)
                    ? Number(fundDetails[0].ownership)
                    : 0;
                if (
                  self.value.detailsData &&
                  self.value.detailsData.length > 0
                ) {
                  let totalLpCommitment = 0;
                  let gpCarry = 0;
                  self.value.detailsData.map((item) => {
                    if (
                      item &&
                      item.hasOwnProperty("entity_type") &&
                      item.entity_type == "LP"
                    ) {
                      if (
                        item.hasOwnProperty("capital_commitment") &&
                        Number(item.capital_commitment) > 0
                      ) {
                        totalLpCommitment += Number(item.capital_commitment);
                      }
                    }
                    if (
                      item &&
                      item.hasOwnProperty("entity_type") &&
                      item.entity_type == "GP Carry"
                    ) {
                      if (
                        item.hasOwnProperty("profit") &&
                        Number(item.profit) > 0
                      ) {
                        gpCarry = Number(item.profit);
                      }
                    }
                  });
                  self.value.detailsData.map((item) => {
                    let capitalCommitment =
                      item.hasOwnProperty("capital_commitment") &&
                      Number(item.capital_commitment) > 0
                        ? Number(item.capital_commitment)
                        : 0;
                    let contributedToDate =
                      item.contributed_to_date &&
                      Number(item.contributed_to_date) > 0
                        ? Number(item.contributed_to_date)
                        : 0;
                    item.capital_called =
                      capitalCommitment &&
                      this.value.summaryData &&
                      this.value.summaryData.hasOwnProperty(
                        "capital_called_to_date"
                      ) &&
                      Number(this.value.summaryData.capital_called_to_date) > 0
                        ? Number(
                            (
                              Number(capitalCommitment) *
                              (Number(
                                this.value.summaryData.capital_called_to_date
                              ) /
                                100)
                            ).toFixed(2)
                          )
                        : 0;
                    let capitalCalled =
                      item.capital_called && Number(item.capital_called) > 0
                        ? Number(item.capital_called)
                        : 0;
                    if (item.entity_type == "LP") {
                      item.ownership = Number(
                        (
                          (Number(capitalCommitment) /
                            Number(fundDetailsCapitalCommitment)) *
                          100
                        ).toFixed(2)
                      );
                    }
                    let ownership =
                      item.hasOwnProperty("ownership") &&
                      Number(item.ownership) > 0
                        ? Number(item.ownership)
                        : 0;
                    item.lp_percentage =
                      item.entity_type == "LP"
                        ? Number(
                            (
                              (Number(capitalCommitment) /
                                Number(totalLpCommitment)) *
                              100
                            ).toFixed(2)
                          )
                        : 0;
                    if (item.entity_type == "LP" || item.entity_type == "GP") {
                      item.profit = Number(
                        (
                          (Number(Number(fundDetailsFundPercentage) / 100) -
                            Number(Number(gpCarry) / 100)) *
                          Number(ownership)
                        ).toFixed(2)
                      );
                    }
                    item.open_balance = Number(
                      (
                        Number(capitalCalled) - Number(contributedToDate)
                      ).toFixed(2)
                    );
                    item.remaining_commitment = Number(
                      (
                        Number(capitalCommitment) -
                        Number(capitalCalled) +
                        Number(item.open_balance)
                      ).toFixed(2)
                    );
                    if (
                      this.value.summaryData &&
                      this.value.summaryData.hasOwnProperty("distributions") &&
                      this.value.summaryData.hasOwnProperty(
                        "distributions_pre_carry"
                      ) &&
                      this.value.summaryData.hasOwnProperty(
                        "distributions_in_carry"
                      ) &&
                      Number(this.value.summaryData.distributions) > 0 &&
                      Number(this.value.summaryData.distributions_pre_carry) &&
                      Number(this.value.summaryData.distributions_in_carry)
                    ) {
                      if (
                        this.value.summaryData.hasOwnProperty(
                          "distributed_to_date"
                        ) &&
                        this.value.summaryData.hasOwnProperty(
                          "capital_commitment"
                        ) &&
                        Number(this.value.summaryData.distributed_to_date) >
                          Number(this.value.summaryData.capital_commitment)
                      ) {
                        //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                        item.distributions = Number(
                          (
                            Number(
                              this.value.summaryData.distributions_pre_carry
                            ) *
                              (Number(ownership) / 100) +
                            Number(
                              this.value.summaryData.distributions_in_carry
                            ) *
                              (Number(item.profit) / 100)
                          ).toFixed(2)
                        );
                      } else {
                        //distrubutions=distributed to date of summary*ownership%
                        item.distributions =
                          (item.entity_type == "LP" ||
                            item.entity_type == "GP") &&
                          Number(this.value.summaryData.distributed_to_date) >
                            0 &&
                          Number(ownership) > 0
                            ? Number(
                                (
                                  Number(
                                    this.value.summaryData.distributed_to_date
                                  ) * Number(Number(ownership) / 100)
                                ).toFixed(2)
                              )
                            : 0;
                      }
                    }
                    // console.info("payload item : ", item);
                    payload.push(item);
                  });
                  self.$store
                    .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
                    .then((data) => {
                      resolve(data);
                    })
                    .catch((error) => {
                      reject(error);
                    });
                } else {
                  resolve();
                }
              })
              .catch((error) => {
                this.$toaster.error("Fail to update");
                console.log(
                  "error in updating lp ownership details inside update lp details",
                  error
                );
              });
          })
          .catch((error) => {
            this.$toaster.error("Fail to update");
            console.log(
              "error in updating gp details inside update lp details",
              error
            );
          });
      });
    },
    contributedToDateChange() {
      let capitalCommitment =
        this.value.data.capital_commitment &&
        Number(this.value.data.capital_commitment) > 0
          ? Number(this.value.data.capital_commitment)
          : 0;
      let contributedToDate =
        this.value.data.contributed_to_date &&
        Number(this.value.data.contributed_to_date) > 0
          ? Number(this.value.data.contributed_to_date)
          : 0;
      let capitalCalled =
        this.value.data.capital_called &&
        Number(this.value.data.capital_called) > 0
          ? Number(this.value.data.capital_called)
          : 0;
      this.value.data.open_balance = Number(
        (Number(capitalCalled) - Number(contributedToDate)).toFixed(2)
      );
      //open balance=total_capital_called of each lp detail-contributed to date of each lp detail
      //remaining commitment=capital commitment of each lp detail-total_capital_called of each lp detail+open balance
      this.value.data.remaining_commitment = Number(
        (
          Number(capitalCommitment) -
          Number(capitalCalled) +
          Number(this.value.data.open_balance)
        ).toFixed(2)
      );
      this.remainingCommitmentValue = this.value.data.remaining_commitment;
    },
    updateGpDetails() {
      const self = this;
      let gpData = self.$store.getters["lpAllocations/gpDetailsData"];
      let fundDetails = self.$store.getters["lpAllocations/fundDetailsData"];
      let fundDetailsCapitalCommitment =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("capital_commitment") &&
        Number(fundDetails[0].capital_commitment)
          ? Number(fundDetails[0].capital_commitment)
          : 0;
      let fundDetailsFundPercentage =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("ownership") &&
        Number(fundDetails[0].ownership)
          ? Number(fundDetails[0].ownership)
          : 0;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (self.value.detailsData && self.value.detailsData.length > 0) {
          let totalLpCommitment = 0;
          let gpCarry = 0;
          self.value.detailsData.map((item) => {
            if (
              item &&
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "LP"
            ) {
              if (
                item.hasOwnProperty("capital_commitment") &&
                Number(item.capital_commitment) > 0
              ) {
                totalLpCommitment += Number(item.capital_commitment);
              }
            }
            if (
              item &&
              item.hasOwnProperty("entity_type") &&
              item.entity_type == "GP Carry"
            ) {
              if (item.hasOwnProperty("profit") && Number(item.profit) > 0) {
                gpCarry = Number(item.profit);
              }
            }
          });
          gpData.map((item) => {
            let ownership =
              item.hasOwnProperty("ownership") && Number(item.ownership) > 0
                ? Number(item.ownership)
                : 0;
            if (item.entity_type == "GP") {
              //gp% of lp capital commitment
              item.capital_commitment = Number(
                (
                  Number(Number(item.ownership) / 100) *
                  Number(totalLpCommitment)
                ).toFixed(2)
              );
              item.profit = Number(
                (
                  (Number(Number(fundDetailsFundPercentage) / 100) -
                    Number(Number(gpCarry) / 100)) *
                  Number(ownership)
                ).toFixed(2)
              );
              item.remaining_commitment = Number(
                (
                  Number(item.capital_commitment) -
                  Number(item.capital_called) +
                  Number(item.open_balance)
                ).toFixed(2)
              );
            }
            if (
              this.value.summaryData &&
              this.value.summaryData.hasOwnProperty("distributions") &&
              this.value.summaryData.hasOwnProperty(
                "distributions_pre_carry"
              ) &&
              this.value.summaryData.hasOwnProperty("distributions_in_carry") &&
              Number(this.value.summaryData.distributions) > 0 &&
              Number(this.value.summaryData.distributions_pre_carry) &&
              Number(this.value.summaryData.distributions_in_carry)
            ) {
              if (
                this.value.summaryData.hasOwnProperty("distributed_to_date") &&
                this.value.summaryData.hasOwnProperty("capital_commitment") &&
                Number(this.value.summaryData.distributed_to_date) >
                  Number(this.value.summaryData.capital_commitment)
              ) {
                //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                item.distributions = Number(
                  (
                    Number(this.value.summaryData.distributions_pre_carry) *
                      (Number(ownership) / 100) +
                    Number(this.value.summaryData.distributions_in_carry) *
                      (Number(item.profit) / 100)
                  ).toFixed(2)
                );
              } else {
                //distrubutions=distributed to date of summary*ownership%
                item.distributions =
                  item.entity_type == "GP" &&
                  Number(this.value.summaryData.distributed_to_date) > 0 &&
                  Number(ownership) > 0
                    ? Number(
                        (
                          Number(this.value.summaryData.distributed_to_date) *
                          Number(Number(ownership) / 100)
                        ).toFixed(2)
                      )
                    : 0;
              }
            }
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateLpOwnership() {
      const self = this;
      let lpData = self.$store.getters["lpAllocations/lpDetailsData"];
      let fundDetails = self.$store.getters["lpAllocations/fundDetailsData"];
      let fundDetailsCapitalCommitment =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("capital_commitment") &&
        Number(fundDetails[0].capital_commitment)
          ? Number(fundDetails[0].capital_commitment)
          : 0;
      let fundDetailsFundPercentage =
        fundDetails &&
        fundDetails.length > 0 &&
        fundDetails[0] &&
        fundDetails[0].hasOwnProperty("ownership") &&
        Number(fundDetails[0].ownership)
          ? Number(fundDetails[0].ownership)
          : 0;
      let payload = [];
      return new Promise((resolve, reject) => {
        if (lpData && lpData.length > 0) {
          let totalLpCommitment = 0;
          // lpData.map((item) => {
          //   if (
          //     item &&
          //     item.hasOwnProperty("entity_type") &&
          //     item.entity_type == "LP"
          //   ) {
          //     if (
          //       item.hasOwnProperty("capital_commitment") &&
          //       Number(item.capital_commitment) > 0
          //     ) {
          //       totalLpCommitment += Number(item.capital_commitment);
          //     }
          //   }
          // });
          lpData.map((item) => {
            let capitalCommitment =
              item.hasOwnProperty("capital_commitment") &&
              Number(item.capital_commitment) > 0
                ? Number(item.capital_commitment)
                : 0;
            if (item.entity_type == "LP") {
              item.ownership = Number(
                (
                  (Number(capitalCommitment) /
                    Number(fundDetailsCapitalCommitment)) *
                  100
                ).toFixed(2)
              );
            }
            payload.push(item);
            self.$store
              .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          });
        } else {
          resolve();
        }
      });
    },
    updateCurrentCapitalCallData() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let lpDetailsData = self.$store.getters["lpAllocations/lpDetailsData"];
      return new Promise((resolve, reject) => {
        if (
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("_id")
        ) {
          let totalLpCapitalCalled = 0;
          let totalLpDistributions = 0;
          let totalFundCapitalCalled =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_called") &&
            Number(fundDetailsData[0].capital_called) > 0
              ? Number(fundDetailsData[0].capital_called)
              : 0;
          let totalFundDistributions =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("distributions") &&
            Number(fundDetailsData[0].distributions) > 0
              ? Number(fundDetailsData[0].distributions)
              : 0;
          let serverData = JSON.parse(JSON.stringify(currentCapitalCallData));
          let previousValue =
            currentCapitalCallData &&
            currentCapitalCallData.hasOwnProperty(
              "capital_called_to_date_amount"
            )
              ? Number(currentCapitalCallData.capital_called_to_date_amount)
              : 0;
          let previouCapitalCalledAmountValue =
            currentCapitalCallData &&
            currentCapitalCallData.hasOwnProperty("capital_called_amount")
              ? Number(currentCapitalCallData.capital_called_amount)
              : 0;
          let presentValue = Number(
            (
              Number(previousValue) - Number(previouCapitalCalledAmountValue)
            ).toFixed(2)
          );
          if (lpDetailsData && lpDetailsData.length > 0) {
            lpDetailsData.map((item) => {
              if (
                item &&
                item.hasOwnProperty("capital_called") &&
                Number(item.capital_called) > 0
              ) {
                totalLpCapitalCalled += Number(item.capital_called);
              }
              if (
                item &&
                item.hasOwnProperty("distributions") &&
                Number(item.distributions) > 0
              ) {
                totalLpDistributions += Number(item.distributions);
              }
            });
          }
          serverData.capital_called_amount =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_commitment") &&
            Number(fundDetailsData[0].capital_commitment) > 0
              ? Number(
                  (
                    Number(serverData.capital_called / 100) *
                    Number(fundDetailsData[0].capital_commitment)
                  ).toFixed(2)
                )
              : 0;
          serverData.capital_called_to_date_amount = Number(
            (
              Number(presentValue) + Number(serverData.capital_called_amount)
            ).toFixed(2)
          );
          serverData.moic =
            Number(this.portfolioValue) > 0 && Number(this.portfolioCost) > 0
              ? Number(
                  (
                    Number(this.portfolioValue) / Number(this.portfolioCost)
                  ).toFixed(2)
                )
              : 0;
          serverData.tvpi =
            Number(totalLpCapitalCalled) > 0
              ? Number(
                  (
                    Number(this.portfolioValue) / Number(totalLpCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          serverData.net_dpi =
            Number(totalLpCapitalCalled) > 0
              ? Number(
                  (
                    Number(totalLpDistributions) / Number(totalLpCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          serverData.gross_dpi =
            Number(totalFundCapitalCalled) > 0
              ? Number(
                  (
                    Number(totalFundDistributions) /
                    Number(totalFundCapitalCalled)
                  ).toFixed(2)
                )
              : 0;
          if (serverData.hasOwnProperty("_id")) {
            self.$store
              .dispatch("lpAllocations/apiPatchCapitalCallData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },
    updateSummaryData() {
      const self = this;
      let currentCapitalCallData =
        self.$store.getters["lpAllocations/currentCapitalCallData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let summaryData = self.$store.getters["lpAllocations/summaryData"];
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      return new Promise((resolve, reject) => {
        let serverData =
          summaryData && summaryData.length > 0
            ? JSON.parse(JSON.stringify(summaryData[0]))
            : {};
        serverData.capital_called =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called") &&
          Number(currentCapitalCallData.capital_called) > 0
            ? Number(currentCapitalCallData.capital_called)
            : 0;
        serverData.capital_called_to_date =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called_to_date") &&
          Number(currentCapitalCallData.capital_called_to_date) > 0
            ? Number(currentCapitalCallData.capital_called_to_date)
            : 0;
        serverData.capital_called_amount =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("capital_called_amount") &&
          Number(currentCapitalCallData.capital_called_amount) > 0
            ? Number(currentCapitalCallData.capital_called_amount)
            : 0;
        serverData.capital_called_to_date_amount =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty(
            "capital_called_to_date_amount"
          ) &&
          Number(currentCapitalCallData.capital_called_to_date_amount) > 0
            ? Number(currentCapitalCallData.capital_called_to_date_amount)
            : 0;
        serverData.current_capital_call =
          currentCapitalCallData && currentCapitalCallData.hasOwnProperty("_id")
            ? currentCapitalCallData._id
            : "";
        serverData.moic =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("moic") &&
          Number(currentCapitalCallData.moic) > 0
            ? Number(currentCapitalCallData.moic)
            : 0;
        serverData.tvpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("tvpi") &&
          Number(currentCapitalCallData.tvpi) > 0
            ? Number(currentCapitalCallData.tvpi)
            : 0;
        serverData.net_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("net_dpi") &&
          Number(currentCapitalCallData.net_dpi) > 0
            ? Number(currentCapitalCallData.net_dpi)
            : 0;
        serverData.gross_dpi =
          currentCapitalCallData &&
          currentCapitalCallData.hasOwnProperty("gross_dpi") &&
          Number(currentCapitalCallData.gross_dpi) > 0
            ? Number(currentCapitalCallData.gross_dpi)
            : 0;
        serverData.capital_commitment =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_commitment") &&
          Number(fundDetailsData[0].capital_commitment) > 0
            ? Number(fundDetailsData[0].capital_commitment)
            : 0;
        serverData.distributions =
          currentDistributionData.hasOwnProperty("distributions") &&
          Number(currentDistributionData.distributions)
            ? Number(currentDistributionData.distributions)
            : 0;
        serverData.distributions_pre_carry =
          currentDistributionData.hasOwnProperty("distributions_pre_carry") &&
          Number(currentDistributionData.distributions_pre_carry)
            ? Number(currentDistributionData.distributions_pre_carry)
            : 0;
        serverData.distributions_in_carry =
          currentDistributionData.hasOwnProperty("distributions_in_carry") &&
          Number(currentDistributionData.distributions_in_carry)
            ? Number(currentDistributionData.distributions_in_carry)
            : 0;
        serverData.distributed_to_date =
          currentDistributionData.hasOwnProperty("distributed_to_date") &&
          Number(currentDistributionData.distributed_to_date)
            ? Number(currentDistributionData.distributed_to_date)
            : 0;
        serverData.current_distribution =
          currentDistributionData &&
          currentDistributionData.hasOwnProperty("_id")
            ? currentDistributionData._id
            : "";
        if (summaryData && summaryData.length > 0) {
          if (serverData && serverData.hasOwnProperty("_id")) {
            self.$store
              .dispatch("lpAllocations/apiPatchSummaryData", serverData)
              .then((data) => {
                resolve(data);
              })
              .catch((error) => {
                reject(error);
              });
          } else {
            resolve();
          }
        } else {
          self.$store
            .dispatch("lpAllocations/apiPostSummaryData", serverData)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        }
      });
    },
    updateDistributionCallData() {
      const self = this;
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      return new Promise((resolve, reject) => {
        if (
          currentDistributionData &&
          currentDistributionData.hasOwnProperty("_id")
        ) {
          let serverData = JSON.parse(JSON.stringify(currentDistributionData));
          serverData.distributed_to_date = serverData.hasOwnProperty(
            "distributed_to_date"
          )
            ? Number(serverData.distributed_to_date)
            : 0;
          serverData.distributions_in_carry =
            fundDetailsData &&
            fundDetailsData.length > 0 &&
            fundDetailsData[0].hasOwnProperty("capital_commitment") &&
            Number(fundDetailsData[0].capital_commitment)
              ? Number(
                  (
                    Number(serverData.distributed_to_date) -
                    Number(fundDetailsData[0].capital_commitment)
                  ).toFixed(2)
                )
              : 0;
          serverData.distributions_pre_carry = Number(
            (
              Number(serverData.distributed_to_date) -
              Number(serverData.distributions_in_carry)
            ).toFixed(2)
          );
          self.$store
            .dispatch("lpAllocations/apiPatchDistributionData", serverData)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
    updateDetailsDataDistributions() {
      const self = this;
      let currentDistributionData =
        self.$store.getters["lpAllocations/currentDistributionData"];
      let detailsData = self.$store.getters["lpAllocations/detailsData"];
      let fundDetailsData =
        self.$store.getters["lpAllocations/fundDetailsData"];
      let payload = [];
      return new Promise((resolve, reject) => {
        let capitalCommitment =
          fundDetailsData &&
          fundDetailsData.length > 0 &&
          fundDetailsData[0].hasOwnProperty("capital_commitment") &&
          Number(fundDetailsData[0].capital_commitment)
            ? Number(fundDetailsData[0].capital_commitment)
            : 0;
        if (detailsData && detailsData.length > 0) {
          detailsData.map((item) => {
            let ownership =
              item.hasOwnProperty("ownership") && Number(item.ownership)
                ? Number(item.ownership)
                : 0;
            let profit =
              item.hasOwnProperty("profit") && Number(item.profit)
                ? Number(item.profit)
                : 0;
            if (
              currentDistributionData &&
              currentDistributionData.hasOwnProperty("distributions") &&
              currentDistributionData.hasOwnProperty(
                "distributions_pre_carry"
              ) &&
              currentDistributionData.hasOwnProperty(
                "distributions_in_carry"
              ) &&
              Number(currentDistributionData.distributions) > 0 &&
              Number(currentDistributionData.distributions_pre_carry) &&
              Number(currentDistributionData.distributions_in_carry)
            ) {
              if (
                currentDistributionData.hasOwnProperty("distributed_to_date") &&
                capitalCommitment &&
                Number(capitalCommitment) &&
                Number(currentDistributionData.distributed_to_date) >
                  Number(capitalCommitment)
              ) {
                //distributions=(Distribution pre-carry of summary*ownership% of lp)+(Distributions in carry of summary*profit% of lp)
                item.distributions = Number(
                  (
                    Number(currentDistributionData.distributions_pre_carry) *
                      (Number(ownership) / 100) +
                    Number(currentDistributionData.distributions_in_carry) *
                      (Number(profit) / 100)
                  ).toFixed(2)
                );
              } else {
                //distrubutions=distributed to date of summary*ownership%
                item.distributions =
                  (item.entity_type == "LP" || item.entity_type == "GP") &&
                  Number(currentDistributionData.distributed_to_date) > 0 &&
                  Number(ownership) > 0
                    ? Number(
                        (
                          Number(currentDistributionData.distributed_to_date) *
                          Number(Number(ownership) / 100)
                        ).toFixed(2)
                      )
                    : 0;
              }
            }
            payload.push(item);
          });
          self.$store
            .dispatch("lpAllocations/apiBulkPatchDetailsData", payload)
            .then((data) => {
              resolve(data);
            })
            .catch((error) => {
              reject(error);
            });
        } else {
          resolve();
        }
      });
    },
  },
};
</script>
<style>
.formLabel {
  color: #000000;
}
</style>